import { useMorningBriefQuery } from './brief';
import { usePulses } from './pulses';
import { useWorkspaces } from './workspaces';

/**
 * Whether the home's NON-dashboard content — the morning brief and the workspaces row, the "workspace and
 * stuff" above the dashboard — has SETTLED (each read finished, success OR failure). The home holds its
 * reveal on this so the catch-up chrome appears in one piece instead of popping in section by section.
 *
 * The DASHBOARD is deliberately excluded: it gets its own skeleton and must never hold the home (its
 * render-handler probe is the slow, sometimes-cold path this whole change exists to decouple).
 *
 * Every signal is error-INCLUSIVE (a failed read still counts as settled, matching how each section
 * degrades to absent), so a single blip can never strand the home behind the loader. The two agent piles
 * (jobs, opportunities) are intentionally NOT gated on: they are secondary, module-cached and degrade to
 * absent, and neither can distinguish "loading" from "failed" to gate on safely.
 *
 * These are the same hooks `BriefSlot` and `CatchUpSections` already call, so React Query dedupes them —
 * reading them here adds no network.
 */
export function useHomeContentReady(): boolean {
  const { settled: briefSettled } = useMorningBriefQuery();
  const { state: pulses } = usePulses();
  const workspaces = useWorkspaces();
  return briefSettled && pulses.kind !== 'loading' && workspaces.status !== 'loading';
}
